import React from "react";

type DiscoverColorProps = React.SVGProps<SVGSVGElement>;

const DiscoverColor: React.FC<DiscoverColorProps> = (props) => {
  // Unique per instance so multiple DiscoverColor renders don't collide on one DOM id.
  const gradientId = React.useId();
  return (
    <svg viewBox="0 0 120 80" role="img" fill="none" {...props}>
      <title>Discover</title>
      <defs>
        <radialGradient
          cx="100%"
          cy="100%"
          fx="100%"
          fy="100%"
          r="113.607178%"
          id={gradientId}
        >
          <stop stopColor="#F59900" offset="0%" />
          <stop stopColor="#F39501" offset="21.0082086%" />
          <stop stopColor="#CE3C0B" offset="90.8163265%" />
          <stop stopColor="#A4420A" offset="100%" />
        </radialGradient>
      </defs>
      <rect fill="#FFFFFF" x="0" y="0" width="120" height="80" rx="4" />
      <ellipse
        fill={`url(#${gradientId})`}
        cx="64.6178824"
        cy="37.61965"
        rx="9.22352941"
        ry="9.1"
      />
      <path
        fill="#E7792B"
        d="M29,80 L116.001926,80 C118.210001,80 120,78.2109725 120,75.9957423 L120,48 C120,48 87.8615894,70.106274 29,80 Z"
      />
      <path
        fill="#1A1918"
        d="M13.1243294,28.89505 L8.24178824,28.89505 L8.24178824,45.71965 L13.0986353,45.71965 C15.6812235,45.71965 17.5456941,45.1184 19.1828706,43.77745 C21.1283765,42.18885 22.2786824,39.7949 22.2786824,37.31905 C22.2786824,32.3537 18.5187765,28.89505 13.1243294,28.89505 L13.1243294,28.89505 Z M17.0100706,41.53365 C15.9645176,42.4651 14.6073412,42.87135 12.4582588,42.87135 L11.5655529,42.87135 L11.5655529,31.74595 L12.4582588,31.74595 C14.6073412,31.74595 15.9111529,32.1249 17.0100706,33.1064 C18.1603765,34.11715 18.8521412,35.683 18.8521412,37.29435 C18.8521412,38.9096 18.1603765,40.52355 17.0100706,41.53365 L17.0100706,41.53365 Z"
      />
      <path
        fill="#1A1918"
        d="M23.8091294,28.89505 L27.1355294,28.89505 L27.1355294,45.71965 L23.8091294,45.71965 L23.8091294,28.89505 Z"
      />
      <path
        fill="#1A1918"
        d="M35.2687059,35.3515 C33.2724706,34.62285 32.6867765,34.14185 32.6867765,33.23315 C32.6867765,32.173 33.7310118,31.3683 35.1646118,31.3683 C36.1614118,31.3683 36.9803294,31.77195 37.8466824,32.7307 L39.5872941,30.48235 C38.1569882,29.248 36.4460235,28.61685 34.5762824,28.61685 C31.5588706,28.61685 29.2576,30.68385 29.2576,33.4379 C29.2576,35.7558 30.3295059,36.94205 33.4529882,38.0516 C34.7554824,38.50465 35.4182588,38.80625 35.7529412,39.0097 C36.4170353,39.43805 36.7497412,40.04385 36.7497412,40.7504 C36.7497412,42.11345 35.6514824,43.12355 34.1671529,43.12355 C32.5807059,43.12355 31.3032471,42.34095 30.5370353,40.87975 L28.3879529,42.9214 C29.9203765,45.1405 31.7611294,46.12395 34.2923294,46.12395 C37.7485176,46.12395 40.1736471,43.85675 40.1736471,40.5996 C40.1736471,37.9268 39.0523294,36.7165 35.2687059,35.3515"
      />
      <path
        fill="#1A1918"
        d="M41.2231529,37.31905 C41.2231529,42.26425 45.1589647,46.0986 50.224,46.0986 C51.6556235,46.0986 52.8816941,45.82105 54.3943529,45.1184 L54.3943529,41.25545 C53.0641882,42.56845 51.8868706,43.0982 50.3788235,43.0982 C47.0287059,43.0982 44.6510118,40.70165 44.6510118,37.29435 C44.6510118,34.0645 47.1038118,31.5165 50.224,31.5165 C51.8104471,31.5165 53.0114824,32.07485 54.3943529,33.4093 L54.3943529,29.5483 C52.9344,28.8177 51.7333647,28.5148 50.3024,28.5148 C45.2630588,28.5148 41.2231529,32.42715 41.2231529,37.31905"
      />
      <path
        fill="#1A1918"
        d="M80.7677176,40.19595 L76.2205176,28.89505 L72.5864471,28.89505 L79.8236235,46.15125 L81.6129882,46.15125 L88.9799529,28.89505 L85.3742118,28.89505 L80.7677176,40.19595"
      />
      <path
        fill="#1A1918"
        d="M90.4840471,45.71965 L99.9177412,45.71965 L99.9177412,42.87135 L93.8078118,42.87135 L93.8078118,38.3298 L99.6924235,38.3298 L99.6924235,35.4802 L93.8078118,35.4802 L93.8078118,31.74595 L99.9177412,31.74595 L99.9177412,28.89505 L90.4840471,28.89505 L90.4840471,45.71965"
      />
      <path
        fill="#1A1918"
        d="M113.087624,33.86235 C113.087624,30.71245 110.888471,28.89505 107.0528,28.89505 L102.120188,28.89505 L102.120188,45.71965 L105.442635,45.71965 L105.442635,38.96095 L105.8768,38.96095 L110.480659,45.71965 L114.571294,45.71965 L109.202541,38.6314 C111.708047,38.12895 113.087624,36.4383 113.087624,33.86235 L113.087624,33.86235 Z M106.4144,36.6411 L105.442635,36.6411 L105.442635,31.5451 L106.467106,31.5451 C108.538447,31.5451 109.665035,32.4018 109.665035,34.0385 C109.665035,35.73045 108.538447,36.6411 106.4144,36.6411 L106.4144,36.6411 Z"
      />
      <path
        fill="#1A1918"
        d="M115.210353,29.5275 C115.210353,29.23305 115.0048,29.0712 114.643106,29.0712 L114.162165,29.0712 L114.162165,30.54995 L114.519906,30.54995 L114.519906,29.97665 L114.938918,30.54995 L115.375718,30.54995 L114.882918,29.94025 C115.0944,29.88435 115.210353,29.7329 115.210353,29.5275 L115.210353,29.5275 Z M114.579859,29.72965 L114.519906,29.72965 L114.519906,29.3429 L114.583812,29.3429 C114.761035,29.3429 114.852612,29.40595 114.852612,29.5327 C114.852612,29.664 114.759718,29.72965 114.579859,29.72965 L114.579859,29.72965 Z"
      />
      <path
        fill="#1A1918"
        d="M114.714918,28.5187 C113.987576,28.5187 113.409788,29.092 113.409788,29.80765 C113.409788,30.5233 113.994165,31.09725 114.714918,31.09725 C115.424471,31.09725 116.004894,30.51745 116.004894,29.80765 C116.004894,29.10175 115.424471,28.5187 114.714918,28.5187 L114.714918,28.5187 Z M114.710306,30.86715 C114.137788,30.86715 113.669365,30.39655 113.669365,29.8096 C113.669365,29.2207 114.131859,28.75075 114.710306,28.75075 C115.280188,28.75075 115.744659,29.23175 115.744659,29.8096 C115.744659,30.39135 115.280188,30.86715 114.710306,30.86715 L114.710306,30.86715 Z"
      />
    </svg>
  );
};

export default DiscoverColor;
